import { AccountStorageAPI } from "./AccountStorageAPI";

// Groups/settings an account manager hid from the account's own users, stored
// once per account in the V4 account `storage` map (like DashboardAPI).
export const DEVCON_VISIBILITY_KEY = "devcon_v4_visibility";

const storage = new AccountStorageAPI();

const emptyVisibility = () => ({
  version: 1,
  hiddenGroups: [],
  hiddenSettings: [],
});

// The blob is free-form JSON, so never trust its shape.
const keyList = (value) =>
  Array.isArray(value) ? value.filter((k) => typeof k === "string" && !!k) : [];

export class DevConVisibilityAPI {
  async get(accountId) {
    const all = await storage.getAll(accountId);
    const data = AccountStorageAPI.decodeContent(
      all?.[DEVCON_VISIBILITY_KEY]?.content
    );
    if (!data) return emptyVisibility();
    return {
      version: data.version || 1,
      hiddenGroups: keyList(data.hiddenGroups),
      hiddenSettings: keyList(data.hiddenSettings),
    };
  }

  async save(accountId, visibility) {
    return storage.setItem(
      accountId,
      DEVCON_VISIBILITY_KEY,
      "DevCon visibility",
      {
        version: 1,
        hiddenGroups: keyList(visibility?.hiddenGroups),
        hiddenSettings: keyList(visibility?.hiddenSettings),
      }
    );
  }
}
